import useQueryParams from 'components/hooks/useQueryParams';
import { useMemo } from 'react';

const useDefaultPdtIteration = ({ pastIterations, pdtIterations }) => {
  const { getQueryParam } = useQueryParams();
  const contextQs = getQueryParam('context');
  const iterationIdQs = getQueryParam('iteration_id');

  const defaultPdtIteration = useMemo(() => {
    if (contextQs && iterationIdQs) {
      try {
        const pastIteration = pastIterations.find(
          iteration => iteration?.id?.toString() === iterationIdQs
        );
        const iterationProviderId = pastIteration.provider_id;
        if (!iterationProviderId)
          throw new Error('iteration provider_id not exists');

        const pdtIteration = pdtIterations.find(
          pdtIteration => pdtIteration.provider_id === iterationProviderId
        );
        return pdtIteration;
      } catch (e) {
        return pdtIterations[0];
      }
    }

    return pdtIterations[0];
  }, [pastIterations, pdtIterations, iterationIdQs, contextQs]);

  return defaultPdtIteration;
};

export default useDefaultPdtIteration;
